<script setup>
import { computed, reactive, ref } from "vue";
import {formatDate} from "@/js/utils/formatDate";

const props = defineProps({
    user:{
        type: Object,
        required: true
    },
    now:{
        type: Date,
        required:true
    }
})

// goldデータはサーバーオブジェクト（null可）、
// 失効間近（expire_soon）があれば失効するゴールド値＋失効日付情報を保持
const gold = ref({
    total: 0,
    expire_soon: null
})

// ゴールド数を3桁区切り表示、失効日付を年跨ぎ判定で最適フォーマット
const formattedGold = computed(() => {
    const format = gold.value.expire_soon && gold.value.expire_soon?.expires_at.getFullYear() !== props.now.getFullYear() ? 'YYYY/_M_/_D_' : '_M_/_D_';
    return {
        gold: {
            total: gold.value.total.toLocaleString(),
            expire_soon: (gold.value.expire_soon !== null ? {
                gold: gold.value.expire_soon?.gold.toLocaleString(),
                expires_at: formatDate(gold.value.expire_soon?.expires_at, format)
            } : null)
        }
    };
})

/**
 * サーバーから受け取るゴールド情報を初期化（数値キャスト＆Date化）
 * @param {{total: number, expire_soon: number}} newGold
 * */
const init = (newGold) => {
    gold.value.total = newGold.total - 0; // 念のためキャスト

    if (newGold.expire_soon !== null) {
        gold.value.expire_soon = {
            gold: newGold.expire_soon.gold - 0,
            expires_at: new Date(newGold.expire_soon.expires_at)
        }
    }
}

defineExpose({
    init,
});

defineOptions({name:'UserGold'})
</script>

<template>
    <dl>
        <dt>{{ user.nickname ?? '' }}</dt>
        <!--<dd> {{ user.wallet_code }}</dd> -->
    </dl>
    <p class="service_header-userinfo-gold" v-cloak>
        {{ formattedGold.gold.total }}
    </p>
    <p class="service_header-userinfo-expire_date" v-if="gold.expire_soon" v-cloak>
        {{ formattedGold.gold.expire_soon.gold }}
        <span>失効間近({{formattedGold.gold.expire_soon.expires_at}})</span>
    </p>
</template>

<style scoped>

</style>
